module.exports = __webpack_public_path__ + "media/images/icon_list/home-560e0f8f33c735b4aecb6e73a18d7efa.svg";